import { useStyletron } from "baseui";
import React from "react";

export const OnClickLink = ({ children, onClick }: { children: React.ReactNode; onClick: () => void }) => {
  const [css, $theme] = useStyletron();

  return (
    <a
      className={css({
        textDecoration: "none",
        color: $theme.colors.accent500,
        ":visited": {
          color: $theme.colors.accent500,
        },
      })}
      href="#"
      onClick={(event) => {
        event.preventDefault();
        onClick();
      }}
    >
      {children}
    </a>
  );
};
